import { useState } from 'react';
import { Box, Button, FormControlLabel, Switch, TextField, Typography } from '@mui/material';

const ReturnSale = ({ onSubmitReturnSale, sale, onCancel, asCredit = true, onToggleAsCredit }) => {
  const existingName = sale?.sale?.nameSale;
  const [creditName, setCreditName] = useState('');
  const needsName = asCredit && !existingName;
  const canSubmit = !needsName || creditName.trim().length > 0;

  return (
    <Box padding={2}>
      <Typography><span>{`Confirma devolucion del articulo ${sale?.article?.name} del pedido ${sale?.sale?.nameSale}?`}</span></Typography>
      <FormControlLabel
        sx={{ mt: 2 }}
        control={<Switch checked={asCredit} onChange={(e) => onToggleAsCredit && onToggleAsCredit(e.target.checked)} />}
        label='Además, emitir un vale para una futura compra'
      />
      {asCredit && (
        <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mt: 0.5 }}>
          El dinero se devuelve igual en este momento; el vale es un crédito adicional a favor del cliente.
        </Typography>
      )}
      {needsName && (
        <TextField
          sx={{ mt: 2 }}
          fullWidth
          size='small'
          label='Nombre para el vale'
          placeholder='¿A nombre de quién queda el vale?'
          helperText='La venta no tiene un nombre asociado, ingresá uno para poder buscar el vale después'
          value={creditName}
          onChange={(e) => setCreditName(e.target.value)}
        />
      )}
      <Box sx={{ mt: 3, display: "flex" }} flexDirection='row' justifyContent='space-between'>
        <Button
          type="submit"
          variant="outlined"
          //onClick={onClose}
          // disabled={saving}
          onClick={() => onCancel && onCancel()}
        >Cancelar</Button>
        <Button
          type="submit"
          variant="outlined"
          disabled={!canSubmit}
          onClick={() => onSubmitReturnSale && onSubmitReturnSale(existingName || creditName.trim())}
        >
          Confirmar
        </Button>
      </Box>
    </Box>
  );
};

export default ReturnSale;